<template>
  <v-autocomplete
    v-if="partners.length > 0"
    v-model="partner"
    :items="partners"
    item-text="companyName"
    item-value="_id"
    return-object
    dense
    solo
    outlined
    flat
    auto-select-first
    hide-details
    autofocus
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.companyName }} </v-list-item-title>
        <v-list-item-subtitle>{{ item.companyUsername }} ({{ item.id }})</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script lang="ts">
import { PartnerEntity } from "@/models/partnerEntity";
import { ConfigModule } from "@/store/modules/config";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Vue } from "vue-property-decorator";
import eventBus from "@/lib/eventBus";

@Component
export default class ThePartnerSelectorList extends Vue {
  loading = false;

  set partner(partner: PartnerEntity) {
    PartnerModule.setPartner(partner);
    eventBus.$emit("partnerLoaded");

    this.$router.push({ name: ConfigModule.partnerSelectorDestinationVue, params: { partnerId: partner._id } });
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partners() {
    return PartnerModule.partners;
  }

  get name() {
    return PartnerModule.partner.companyName;
  }

  get partnerId() {
    return PartnerModule.partner._id;
  }

  getAddressText(partner: PartnerEntity) {
    const zip = partner?.address?.zip || "";
    const city = partner?.address?.city || "";
    const street = partner?.address?.street || "";

    return `${street} ${zip} ${city}`;
  }
}
</script>

<style lang="css" scoped></style>
